// src/services/api.ts
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://localhost:7077',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
api.interceptors.request.use((config) => {
  // Add API key header (required by ApiKeyMiddleware)
  const apiKey = process.env.REACT_APP_API_KEY;
  if (apiKey) {
    config.headers['X-API-Key'] = apiKey;
  } else {
    console.error('API key not found in environment variables');
  }

  // Add JWT token for user authentication (if available)
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle specific error cases
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Check if it's an API key issue vs JWT token issue
          if (error.response.data?.error?.includes('API key')) {
            console.error('API key authentication failed');
            // Don't redirect to login for API key issues
          } else {
            // Handle unauthorized JWT - clear auth data and redirect to login
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
          }
          break;
        case 404:
          console.error('Resource not found');
          break;
        case 500:
          console.error('Server error');
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default api;